import { Col, Form, Row } from "react-bootstrap";

export interface StructuredRegDataComparisonRowProps {
    mode: "display" | "edit";
    editedValue?: Record<string, unknown>;
    onChange?: (editedValue: Record<string, unknown>) => void;
    displayCode?: string;
    displayDescription?: string;
    rawValue?: string;
    /** When "below", description renders under the code in muted text (System Data). */
    descriptionPlacement?: "inline" | "below";
}

export function StructuredRegDataComparisonRow({
    mode,
    editedValue,
    onChange,
    displayCode,
    displayDescription,
    rawValue,
    descriptionPlacement = "inline",
}: StructuredRegDataComparisonRowProps) {
    if (mode === "display") {
        if (displayCode || displayDescription) {
            if (descriptionPlacement === "below") {
                return (
                    <div className="small">
                        {displayCode ? <div><span>{displayCode}</span></div> : null}
                        {displayDescription ? <div className="text-muted">{displayDescription}</div> : null}
                    </div>
                );
            }

            return (
                <div className="small">
                    {displayCode ? <span>{displayCode}</span> : null}
                    {displayCode && displayDescription ? <span> — </span> : null}
                    {displayDescription ? <span>{displayDescription}</span> : null}
                </div>
            );
        }
        return <div className="small">{rawValue ?? ""}</div>;
    }

    const code = String(editedValue?.code ?? "");
    const description = String(editedValue?.description ?? "");

    return (
        <Row className="g-2 small">
            <Col md={4}>
                <Form.Group>
                    <Form.Label className="mb-0">Code</Form.Label>
                    <Form.Control
                        size="sm"
                        value={code}
                        onChange={(e) => onChange?.({ ...editedValue, code: e.target.value })}
                    />
                </Form.Group>
            </Col>
            <Col md={8}>
                <Form.Group>
                    <Form.Label className="mb-0">Description</Form.Label>
                    <Form.Control
                        size="sm"
                        value={description}
                        onChange={(e) => onChange?.({ ...editedValue, description: e.target.value })}
                    />
                </Form.Group>
            </Col>
        </Row>
    );
}
